exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".studentClozeStatus{margin-left:10px;margin-bottom:25px}.studentClozeStatus .clozeHeader{font-size:1.4em}.studentClozeStatus .cLeft,.studentClozeStatus .progress{display:inline-block;width:500px;max-width:70%}.studentClozeStatus .actionButton{display:inline-block;margin-left:5%;vertical-align:bottom}.studentClozeStatus .progress{margin-bottom:0;margin-top:-14px;vertical-align:bottom}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/students/student_cloze_status.scss
// module id = 1430
// module chunks = 0